<template>
  <div class="edit-password-container">
    <updatePassword></updatePassword>
  </div>
</template>

<script>
import updatePassword from "../updatePassword";
export default {
  name: "EditLoginPassword",
  components: {
    updatePassword
  }
};
</script>

<style scoped>
.edit-password-container {
  padding: 20px;
}
</style>
